import { IconProps } from "@/src/sb/business-layer/types"
import React from "react"

const RecycleIcon = ({ width, height, size }: IconProps) => (
  <svg
    width={width ?? size ?? 12}
    height={height ?? size ?? 12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.72125 8.25L5.625 6.15375V2.625H6.375V5.8425L8.25 7.72125L7.72125 8.25ZM6 0.75C4.58699 0.7502 3.23424 1.32241 2.25 2.33625V0.75H1.5V3.75H4.5V3H2.655C4.10662 1.38691 6.5027 1.03959 8.3526 2.17411C10.2025 3.30864 10.9792 5.60179 10.1995 7.62697C9.41981 9.65215 7.30585 10.8324 5.17275 10.4335C3.03965 10.0345 1.4951 8.17008 1.5 6H0.75C0.75 8.8995 3.10051 11.25 6 11.25C8.8995 11.25 11.25 8.8995 11.25 6C11.25 3.10051 8.8995 0.75 6 0.75Z"
      fill="currentColor"
    />
  </svg>
)

export default RecycleIcon
